/**
 * Reducer
 */
import {reducers} from './rootReducer';

import { createStore, applyMiddleware} from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import { syncOrderToDb } from './components/orders/middlewares';


/**
 * middleware
 */


export const store = createStore(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(syncOrderToDb, promiseMiddleware())
)



// WEBPACK FOOTER //
// ./src/store.js